// GTM ecommerce events sent along with AJAX responses (buy and cart-recalculate forms, see naja.buyConfirm.js).
// Pushed on 'payload', which fires before 'success' - the cart page answers with a hard redirect there.
naja.registerExtension({
    initialize: function(naja) {
        naja.addEventListener('payload', function(event) {
            var payload = event.detail.payload;
            if (payload && payload.gtm && gtmEnabled && typeof dataLayer !== 'undefined' && (!cookieBlocker || (cookieBlocker && (cookieBlockerGtmMode || window.cookiehub.hasConsented("analytics"))))) {
                dataLayer.push(payload.gtm);
            }
        });
    }
});
